import { createContext, useContext, useState, type ReactNode } from "react";

type HeaderActionsContextType = {
  actions: ReactNode;
  setActions: (actions: ReactNode) => void;
};

const HeaderActionsContext = createContext<HeaderActionsContextType | null>(
  null,
);

export const HeaderActionsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [actions, setActions] = useState<ReactNode>(null);

  return (
    <HeaderActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </HeaderActionsContext.Provider>
  );
};

export const useHeaderActions = () => {
  const context = useContext(HeaderActionsContext);
  if (!context) {
    throw new Error(
      "useHeaderActions must be used within HeaderActionsProvider",
    );
  }
  return context;
};

export const HeaderActionsSlot = () => {
  const { actions } = useHeaderActions();
  return <>{actions}</>;
};
